import { NavLink } from "react-router-dom"
import { cn } from "@/lib/utils"

const links: { to: string; label: string; end?: boolean }[] = [
  { to: "/dashboard/media", label: "Videos", end: true },
  { to: "/dashboard/media/settings", label: "Podcast" },
  { to: "/dashboard/media/series", label: "Series" },
  { to: "/dashboard/media/speakers", label: "Speakers" },
  { to: "/dashboard/media/topics", label: "Topics" },
]

export function MediaSectionNav() {
  return (
    <nav className="mb-4" aria-label="Media section">
      <div className="inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground">
        {links.map(({ to, label, end: endMatch }) => (
          <NavLink
            key={to}
            to={to}
            end={endMatch}
            className={({ isActive }) =>
              cn(
                "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all",
                isActive
                  ? "bg-background text-foreground shadow-sm"
                  : "hover:text-foreground"
              )
            }
          >
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
